import { Tooltip } from "antd"
import { type ReactNode } from "react"

import { SHARE_LOCK_TOOLTIP } from "./standoutReviewCardHelpers"

/**
 * A disabled button fires no pointer events, so the tooltip sits on a
 * wrapper. The button inside should set `pointerEvents: "none"`.
 */
const ShareLockTooltip = ({
  locked,
  title = SHARE_LOCK_TOOLTIP,
  children,
}: {
  locked: boolean
  title?: string
  children: ReactNode
}) =>
  locked ? (
    <Tooltip title={title}>
      <span
        data-testid="sr-share-lock"
        style={{
          display: "inline-flex",
          width: "fit-content",
          cursor: "not-allowed",
        }}
      >
        {children}
      </span>
    </Tooltip>
  ) : (
    children
  )

export default ShareLockTooltip
